import { roles } from "shared/constants/Constants.js";

/**
 * Report pages get userRole/role from Redux or useAgentAccountDetails() inside the component.
 * Route config only declares path + lazy load; no prop injection in the routing layer.
 */
const reportsRoutes = {
  dashboard: [
    {
      path: "tripActivity",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "trip-activity-list" */
          "./dashboard/TripActivityList.js"
        ),
      authorized: [roles.VENDOR],
      sidebarGroup: "reports",
      sidebarLabel: "Trip Activity",
    },
    {
      path: "transactionReports",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "performance-transactions" */
          "./dashboard/PerformanceTransactions.js"
        ),
      authorized: [roles.VENDOR],
      sidebarGroup: "reports",
      sidebarLabel: "Transactions",
    },
    {
      path: "deploymentVehicleReports",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "vehicle-report" */
          "./dashboard/VehicleReport.js"
        ),
      authorized: [
        roles.ADMIN,
        roles.HUB_MANAGER,
        roles.FINANCE,
        roles.SENIOR_DRIVER_MANAGER,
        roles.FLEET_GENERAL_MANAGER,
        roles.FLEET_MANAGER,
      ],
      sidebarGroup: "reports",
      sidebarLabel: "Vehicle Reports",
    },
    {
      path: "deploymentExceptionReports",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "exception-reports-deployment" */
          "./dashboard/ExceptionReportsDeployment.js"
        ),
      authorized: [roles.ADMIN, roles.SENIOR_DRIVER_MANAGER, roles.HUB_MANAGER],
      sidebarGroup: "reports",
      sidebarLabel: "Reports",
    },
    {
      path: "PermanentDropExceptionReports",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "permanent-drop-exception-report" */
          "./dashboard/PermanentDropExceptionReport.js"
        ),
      authorized: [
        roles.ADMIN,
        roles.HUB_MANAGER,
        roles.ONBOARDING,
        roles.DRIVER_MANAGER,
        roles.SENIOR_DRIVER_MANAGER,
      ],
      sidebarGroup: "reports",
      sidebarLabel: "Permanent Drop",
    },
    {
      path: "settlementExceptionReports",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "settlement-exception-reports" */
          "./dashboard/SettlementExceptionReports.js"
        ),
      authorized: [roles.ADMIN],
      sidebarGroup: "reports",
      sidebarLabel: "Exception Reports",
    },
    {
      path: "collectionSettlement",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "collection-settlement" */
          "./dashboard/CollectionSettlement.js"
        ),
      authorized: [roles.ADMIN, roles.HUB_MANAGER, roles.SENIOR_DRIVER_MANAGER],
      sidebarGroup: "reports",
      sidebarLabel: "Collection Reports",
    },
    {
      path: "paymentTagUpdates",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "payment-tag-updates" */
          "./dashboard/PaymentTagUpdatesReport.js"
        ),
      authorized: [roles.ADMIN, roles.FINANCE, roles.COMMERCIAL],
      sidebarGroup: "reports",
      sidebarLabel: "Payment Tag Updates",
    },
    {
      path: "ws-history-report",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "ws-history-report" */
          "./dashboard/WSHistory.js"
        ),
      authorized: [
        roles.ADMIN,
        roles.HUB_MANAGER,
        roles.DRIVER_MANAGER,
        roles.FLEET_GENERAL_MANAGER,
        roles.FLEET_MANAGER,
      ],
      sidebarGroup: "reports",
      sidebarLabel: "W/S History",
    },
    {
      path: "ws-mismatch-report",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "ws-mismatch-report" */
          "./dashboard/WSMismatch.js"
        ),
      authorized: [
        roles.ADMIN,
        roles.HUB_MANAGER,
        roles.FLEET_GENERAL_MANAGER,
        roles.FLEET_MANAGER,
      ],
      sidebarGroup: "reports",
      sidebarLabel: "W/S Mismatch",
    },
    {
      path: "ws-exception-report",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "ws-exception-report" */
          "./dashboard/WSExceptionReport.js"
        ),
      authorized: [
        roles.ADMIN,
        roles.HUB_MANAGER,
        roles.FLEET_MANAGER,
        roles.FLEET_GENERAL_MANAGER,
      ],
      sidebarGroup: "reports",
      sidebarLabel: "W/S Exception",
    },

    {
      path: "carSwapExceptionReport",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "car-swap-exception" */
          "./dashboard/CarSwapExceptionReport.js"
        ),
      authorized: [roles.HUB_MANAGER, roles.ADMIN, roles.FLEET_GENERAL_MANAGER],
      sidebarGroup: "reports",
      sidebarLabel: "Car Swap Report",
    },

    {
      path: "unverifiedUberIdReport",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "unverified-uber-id" */
          "./dashboard/UnverifiedUberIdReport.js"
        ),
      authorized: [roles.ADMIN, roles.HUB_MANAGER],
      sidebarGroup: "reports",
      sidebarLabel: "Unverified Uber ID",
    },
    {
      path: "sd-discount-report",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "sd-discount-report" */
          "./dashboard/SdDiscountReport.js"
        ),
      authorized: [roles.ADMIN],
      sidebarGroup: "reports",
      sidebarLabel: "SD Discount",
    },
    {
      path: "handover-receive-report",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "handover-receive-images-report" */
          "./dashboard/HandoverReceiveImagesReport.js"
        ),
      authorized: [roles.HUB_MANAGER, roles.PARKING, roles.ADMIN],
      sidebarGroup: "reports",
      sidebarLabel: "Images Report",
    },
    {
      path: "uber-reports",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "handover-receive-images-report" */
          "./dashboard/UberReports.js"
        ),
      authorized: [roles.ADMIN, roles.COMMERCIAL, roles.FINANCE],
      sidebarGroup: "reports",
      sidebarLabel: "Uber Reports",
      protected: true,
    },
  ],
  standalone: [],
};

export default reportsRoutes;
